import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faEnvelope as farEnvelope } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { faEnvelope as fasEnvelope } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, List } from "bm-ui-kit";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export interface StepFields {}

interface Props extends AbstractStepProps {}

export class Result extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header className="text-center mt-2">{this.renderHeader()}</Card.Header>
				<Card.Body className="d-flex flex-column">
					<hr className="my-2 w-100" />
					<div className="d-flex block-with-icon">
						<div className="text-center px-2">
							<FontAwesomeIcon icon={farEnvelope} className="text-gold" size="5x" />
						</div>
						<div className="px-2 text-white text-block">
							A részleteket <strong className="text-nowrap">e-mailben</strong> fogjuk elküldeni számodra!
						</div>
					</div>
					<hr className="my-2 w-100" />
					<div>
						A <span className="text-uppercase">hitelfedezeti biztosítás</span> részleteit emailben küldjük
						el neked a következő fontos információkkal:
					</div>
					{this.renderList()}
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						variant="gold"
						icon={<FontAwesomeIcon icon={fasEnvelope} />}
						size="lg"
						className="text-uppercase"
					>
						Kérem a részleteket
					</Button>
				</Card.Footer>
			</>
		);
	}

	private renderHeader(): ReactNode {
		return <div className="h3 text-uppercase mb-0 text-white font-weight-bold my-1">MÁR CSAK EGYETLEN LÉPÉS!</div>;
	}

	private renderList(): ReactNode {
		return (
			<List itemStyle="tick" variant="gold" className="my-auto">
				<List.Item>
					<strong>Milyen</strong> esetekben véd?
				</List.Item>
				<List.Item>
					<strong>Mennyibe</strong> kerül a szolgáltatás?
				</List.Item>
				<List.Item>
					<strong>Mennyit</strong> fizet a biztosító?
				</List.Item>
			</List>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success result-page"]).join(" ");
	}

	protected getComponentName(): string {
		return "Result";
	}
}
